export const berryCake = {
  id: "berryCake",
  link: "/#/recipes/recipes/berryCake",
  name: "Berry Cake",
  cuisine: "Azish",
  summary: "A yeasted cake with berries",
  inspiration: "Kugelhopf",
  quantity: "1 cake",
  time: "3 hours 15 minutes",
  notes:
    'These days, we associate cake with baking powder. Before baking powder and baking soda, though, cakes were made with yeast. I looked for yeasted cakes that contained fruit and found Kugelhopf. I used blueberries, assuming that blueberries are similar to the fruit used in bluebar jam. (The Way of Kings ch 39) The crumble topping ends up on the bottom of the cake, which is strange. I enjoyed it, though, and thought that it helped make this feel a bit more "alien." Finally, I decided to use wheat and dairy even though we have no indication those are common in Azir, because this cake was served at the palace. If anyone has access to foreign ingredients, it\'s going to be the chefs at the imperial palace in Azimir.',
  quotes:
    '"Mistress wants some cake,"... "Wrong type," Lift said. "Mistress wants berry cake." (Words of Radiance Interlude I-9)',
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/berry-cake-overview.jpg",
  ingredientSections: [
    {
      title: "Cake",
      ingredients: [
        {
          item: "dairy",
          display: "2/3 cup butter, softened"
        },
        {
          item: "sugar",
          display: "2/3 cup granulated sugar"
        },
        {
          item: "blueberries",
          display: "2 cups blueberries"
        },
        {
          item: "eggs",
          display: "3 eggs"
        },
        {
          item: "wheatFlour",
          display: "4 cups all-purpose flour"
        },
        {
          item: "yeast",
          display: "1 tsp active dry yeast"
        },
        {
          item: "dairy",
          display: "1 1/4 cups milk"
        },
        {
          item: "salt",
          display: "1/4 tsp salt"
        },
        {
          item: "lemon",
          display: "1 tsp lemon juice"
        }
      ]
    },
    {
      title: "Topping",
      ingredients: [
        {
          item: "brownSugar",
          display: "3 tbsp brown sugar"
        },
        {
          item: "wheatFlour",
          display: "3 tbsp all-purpose flour"
        },
        {
          item: "cinnamon",
          display: "1/2 tsp ground cinnamon"
        },
        {
          item: "cloves",
          display: "1/4 tsp ground cloves"
        },
        {
          item: "dairy",
          display: "3 tbsp butter"
        }
      ]
    }
  ],
  steps: [
    "Cream together 2/3 butter and 2/3 cup sugar. Beat in 3 eggs just until combined. Mix in 4 cups flour and the yeast just until combined. It will be crumbly.",
    "Warm the milk (in a saucepan on the stove, or in the microwave) to 110 degrees Fahrenheit. Add it to the flour mixture along with the lemon juice and salt. Mix until combined.",
    "If using frozen blueberries, microwave them about 1 minute or until partially defrosted but still slightly icy. Fold the berries into the dough.",
    "Grease a Bundt or tube cake pan, then spread the mixture in the pan. Cover with a clean towel and let rise in a warm place for 2 hours.",
    "Meanwhile, for the topping, in a bowl combine the brown sugar, 3 tbsp flour, cinnamon, and cloves. Cut or crumble in the 3 tbsp butter.",
    "Heat the oven to 350 degrees Fahrenheit. Once the cake has risen, sprinkle topping over the cake. Bake for 35-40 minutes or until a toothpick inserted comes out clean.",
    "Remove from the oven and let cool 5 minutes. Loosen the cake from the edge of the pan with a spatula, then invert and carefully remove the pan. Serve warm."
  ]
}
